import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function useCheckUser(userID) {
    const navigate = useNavigate();

  useEffect(() => {
    if (userID == null) {
      navigate("/login");
    }
  }, [userID]);
}

export default useCheckUser;
